module.exports = "<div>\r\n  <!-- include a footer with logo and horizontal line later -->\r\n</div>\r\n<div class=\"spacer--footer\"></div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/footer/footer.html
 ** module id = 402
 ** module chunks = 0
 **/